import Footer from "../components/Footer";
import { products } from "../data/products";
import { formatPrice } from "../utils/formatPrice";
// Sidebar uses a compact product list instead of full `ProductCard`

const samplePosts = [
  {
    id: 101,
    title: "Ritual Morning Glow",
    author: "Asha Gupta",
    date: "May 2, 2024",
    excerpt: "A simple morning ritual to boost hydration and radiance.",
    tags: ["routine", "hydration"],
    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: 102,
    title: "Hero Ingredients Explained",
    author: "Rohan Mehta",
    date: "Mar 14, 2024",
    excerpt: "What Niacinamide, Azelaic Acid, and Turmeric do for your skin.",
    tags: ["ingredients", "science"],
    image: "https://images.unsplash.com/photo-1556228720-9f24b3bbcc52?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: 103,
    title: "Sunscreen Myths",
    author: "Sahana Singh",
    date: "Jan 9, 2024",
    excerpt: "Separating fact from fiction when it comes to SPF and protection.",
    tags: ["sunscreen", "spf"],
    image: "https://images.unsplash.com/photo-1501004318641-b39e6451bec6?auto=format&fit=crop&w=1200&q=80",
  },
];

const allTags = Array.from(new Set(samplePosts.flatMap((p) => p.tags)));

const Blog = ({ onOpenDetails, onAddToCart, onToggleWishlist, cartItems = {}, wishlistItems = {} }) => {
  const featured = samplePosts[0];

  return (
    <>
      <main className="page-shell blog-page">
        <section className="blog-hero">
          <div className="section-container">
            <p className="eyebrow">From the ritual</p>
            <h1>Journal</h1>
            <p className="hero-text">Articles, rituals, and ingredient deep dives to guide your routine.</p>
          </div>
        </section>

        <section className="section-container blog-layout">
          <div className="blog-main">
            <article className="featured-post">
              <div className="featured-media" style={{ backgroundImage: `url(${featured.image})` }} />
              <div className="featured-copy">
                <p className="post-meta">{featured.date} • {featured.author}</p>
                <h2>{featured.title}</h2>
                <p className="post-excerpt">{featured.excerpt}</p>
                <div className="post-actions">
                  <a className="primary-btn" href="#/blog">Read full article</a>
                  <a className="text-link" href="#/shop">Shop related products</a>
                </div>
              </div>
            </article>

            <div className="post-list">
              {samplePosts.slice(1).map((post) => (
                <article className="blog-post" key={post.id}>
                  <img src={post.image} alt={post.title} />
                  <div>
                    <p className="post-meta">{post.date} • {post.author}</p>
                    <h3>{post.title}</h3>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-footer">
                      <div className="tag-list">{post.tags.map((t) => (<button key={t} className="tag-btn">{t}</button>))}</div>
                      <a className="text-link" href="#/blog">Read more</a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside className="blog-sidebar">
            <div className="sidebar-card">
              <h4>Recent posts</h4>
              <ul>
                {samplePosts.map((p) => (
                  <li key={p.id}><a href="#/blog">{p.title}</a></li>
                ))}
              </ul>
            </div>

            <div className="sidebar-card">
              <h4>Tags</h4>
              <div className="tag-cloud">
                {allTags.map((t) => (
                  <button key={t} className="tag-btn">{t}</button>
                ))}
              </div>
            </div>

            <div className="sidebar-card">
              <h4>Product highlights</h4>
              <div className="sidebar-products">
                {products.slice(0, 4).map((item) => (
                  <div className="sidebar-product" key={item.id}>
                    <button
                      type="button"
                      className="sidebar-prod-thumb"
                      onClick={() => onOpenDetails(item)}
                      aria-label={`Open ${item.name} details`}
                    >
                      <img src={item.image} alt={item.name} />
                    </button>

                    <div className="sidebar-prod-meta">
                      <h5>{item.name}</h5>
                      <strong>{formatPrice(item.price)}</strong>
                      <div className="sidebar-prod-actions">
                        <button type="button" onClick={() => onAddToCart(item)}>Add</button>
                        <button type="button" onClick={() => onToggleWishlist(item.id)} className="text-link">♡</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Blog;
